import type {AppEntityCrudConfig} from "#src/hooks/useAppEntityCrud/useAppEntityCrud";

export interface AppEntityCrudDefinition<TRow, TWithRelations> {
	__entityTypes?: [TRow, TWithRelations]
	apiSegment: string
	viewEntityName?: string
	getAllUrl?: string
	createUrl?: string
	getByIdUrlTemplate?: (id: any) => string
	updateUrlTemplate?: (id: any) => string
	deleteUrlTemplate?: (id: any) => string
	patchUrlTemplate?: (id: number | string, action: string) => string
	customApiPost?: (id: number | string, action: string) => string
	skipDefaultIdDescListSort?: boolean
}

export function createAppEntityCrudConfig<TRow, TWithRelations>(
	def: AppEntityCrudDefinition<TRow, TWithRelations>,
): AppEntityCrudConfig<TRow, TWithRelations> {
	const apiSegment = `${def.apiSegment}`;
	// const getByIdTemplate = def.getByIdTemplate || (id => `/${id}`);

	return {
		getAllUrl: def.getAllUrl ?? apiSegment,
		createUrl: def.createUrl ?? apiSegment,
		getByIdUrl: id => def.getByIdUrlTemplate?.(id) ?? `${apiSegment}/${id}`,
		getUpdateUrl: id => def.updateUrlTemplate?.(id) ?? `${apiSegment}/${id}`,
		getDeleteUrl: id => def.deleteUrlTemplate?.(id) ?? `${apiSegment}/${id}`,
		getPatchUrl: (id, action) => def.patchUrlTemplate?.(id, action) ?? `${apiSegment}/${id}/${action}`,
		getCustomApiPost: (id, action) => def.customApiPost?.(id, action) ?? `${apiSegment}/${id}/${action}`,
		entityPluralName: def.getAllUrl ?? def.apiSegment,
		skipDefaultIdDescListSort: def.skipDefaultIdDescListSort,
	};
}
